var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterConnectionOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ON",
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 27,
    viewBox: "0 0 121 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M74.81,27H0V21.88H74.81a3.391,3.391,0,0,0,3.41-3.36V8.48A8.551,8.551,0,0,1,86.83,0H121V5.12H86.83a3.391,3.391,0,0,0-3.41,3.36V18.51A8.56,8.56,0,0,1,74.81,27Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterConnectionOn);
export default __webpack_public_path__ + "static/media/water_connection_on.d3349ff5e1a60b13973f9cfba7a6139c.svg";
export { ForwardRef as ReactComponent };